import { render } from "./createByLicense.vue?vue&type=template&id=3226f522"
import script from "./createByLicense.vue?vue&type=script&lang=js"
export * from "./createByLicense.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__